import React, { useState } from "react";
import MapLeftSidebar from "./components/MapLeftSidebar";
import { useSearchParams } from "react-router-dom";
import MapboxBaseMap from "components/Map/MapboxBaseMap";
import MapboxGeoJSONMap from "./components/MapboxGeoJSONMap";
import MapboxDrawMap from "./components/MapboxDrawMap";

const Map = () => {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [drawLocationName, setDrawLocationName] = useState({});
  const [searchParams] = useSearchParams();

  const toggleLocationSelection = (prevSelectedLocations, location) => {
    const locationId = location.properties.FID_1;
    const locationExists = prevSelectedLocations.some(
      (loc) => loc.properties.FID_1 === locationId
    );

    return locationExists
      ? prevSelectedLocations.filter(
          (loc) => loc.properties.FID_1 !== locationId
        )
      : [...prevSelectedLocations, location];
  };

  const handleMapLocationSelect = (location) => {
    setSelectedLocations((prevSelectedLocations) => {
      const updatedSelectedLocations = toggleLocationSelection(
        prevSelectedLocations,
        location
      );

      const locationId = location.properties.FID_1;
      if (
        !prevSelectedLocations.some(
          (loc) => loc.properties.FID_1 === locationId
        )
      ) {
        const checkboxElement = document.getElementById(locationId);
        if (checkboxElement) {
          checkboxElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }

      return updatedSelectedLocations;
    });
  };

  const handleLocationRemove = (layerId) => {
    setSelectedLocations((prevLocations) =>
      prevLocations.filter((location) => location.properties?.FID_1 !== layerId)
    );
  };

  const mapType = searchParams.get("mapType") || "geojson";

  return (
    <div className="flex relative h-screen max-h-screen overflow-hidden">
      <MapLeftSidebar
        mapType={mapType}
        drawLocationName={drawLocationName}
        selectedLocations={selectedLocations}
        setSelectedLocations={setSelectedLocations}
        toggleLocationSelection={toggleLocationSelection}
        handleMapLocationSelect={handleMapLocationSelect}
        setDrawLocationName={setDrawLocationName}
        handleLocationRemove={handleLocationRemove}
      />

      {mapType === "geojson" && (
        <MapboxGeoJSONMap
          selectedLocations={selectedLocations}
          onLocationSelect={handleMapLocationSelect}
        />
      )}
      {mapType === "draw" && (
        <MapboxDrawMap
          onLocationSelect={handleMapLocationSelect}
          onLocationRemove={handleLocationRemove}
        />
      )}
    </div>
  );
};

export default Map;
